<div class="branch_2">
  <h4 style="text-align: center;margin-top: 10% !important;">{{'EXPENDITURE_COMMITMENT.WORKING' | translate }}</h4>
  <h4 style="text-align: center;">{{'EXPENDITURE_COMMITMENT.WAIT' | translate }}</h4>
  <div class="row" style="margin-top: 30px;">
    <div class="spinner-container">
      <div class="spinner-wheel"
           style=" width: 50px; height: 50px;border: 2px solid #313344; border-left-color:  transparent; border-right-color:  transparent;"></div>
    </div>
  </div>
</div>
